const format = (value, format) => {
    let formattedValue = value

    if (format === 'cardNumber') {
        formattedValue = formattedValue.replace(/\D/g, '') // Remove tudo o que não é dígito
        formattedValue = formattedValue.replace(/(\d{4})(\d)/, '$1 $2')
            .replace(/(\d{4})(\d)/, '$1 $2')
            .replace(/(\d{4})(\d)/, '$1 $2')
        formattedValue = fixInputLength(formattedValue, 19)
    } else if (format === 'cardDate') {
        formattedValue = formattedValue.replace(/\D/g, '')
        formattedValue = formattedValue.replace(/(\d{2})(\d)/, '$1/$2')
        formattedValue = fixInputLength(formattedValue, 5)
    } else if (format === 'cardCVV') {
        formattedValue = formattedValue.replace(/\D/g, '')
        formattedValue = fixInputLength(formattedValue, 3)
    } else if (format === 'cellNumber') {
        formattedValue = formattedValue.replace(/\D/g, '')
        formattedValue = formattedValue.replace(/(\d{2})(\d)/, '($1) $2')
        formattedValue = formattedValue.replace(/(\d{5})(\d)/, '$1-$2')
        formattedValue = fixInputLength(formattedValue, 15)
    } else if (format === 'phoneNumber') {
        formattedValue = formattedValue.replace(/\D/g, '')
        formattedValue = formattedValue.replace(/(\d{2})(\d)/, '($1) $2')
        formattedValue = formattedValue.replace(/(\d{4})(\d)/, '$1-$2')
        formattedValue = fixInputLength(formattedValue, 14)
    } else if (format === 'cpf') {
        formattedValue = formattedValue.replace(/\D/g, '')
        formattedValue = formattedValue.replace(/(\d{3})(\d)/, '$1.$2')
        formattedValue = formattedValue.replace(/(\d{3})(\d)/, '$1.$2')
        formattedValue = formattedValue.replace(/(\d{3})(\d)/, '$1-$2')
        formattedValue = fixInputLength(formattedValue, 14)
    } else if (format === 'cep') {
        formattedValue = formattedValue.replace(/\D/g, '')
        formattedValue = formattedValue.replace(/(\d{5})(\d)/, '$1-$2')
        formattedValue = fixInputLength(formattedValue, 9)
    } else if (format === 'currency') {
        const previouslyFormatted = ('' + formattedValue).includes('R$')
        if (!previouslyFormatted) formattedValue = parseFloat(formattedValue).toFixed(2)
        formattedValue = formattedValue.replace(/\D/g, '')
        const numberValue = parseInt(formattedValue) / 100
        formattedValue = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(numberValue)
    }

    return formattedValue
}

const fixInputLength = (inputValue, length) => {
    if (inputValue.length > length) {
        inputValue = inputValue.slice(0, length)
    }
    return inputValue
}

const sanitizeString = (text) => {
    return text.trim()
}

const sanitizeNumber = (value) => {
    return ('' + value).replace(/\D/g, '')
}

const sanitizeMoney = (value) => {
    value = ('' + value).replace(/\D/g, '')
    return parseFloat(value / 100)
}

export { format, sanitizeString, sanitizeNumber, sanitizeMoney }
